import { compose } from "infrastructure/store";
import useSearchCriteriaFilter from "./useSearchCriteriaFilter";

export default function usePaymentMethodFilter() {
    const { filter, ...restSearchCriteriaFilter } = useSearchCriteriaFilter();

    return {
        ...restSearchCriteriaFilter,
        filter: compose(filter)
    };
};
